import Vue from 'vue'
import zh from "@/commom/language/zh";
import ru from "@/commom/language/ru";

let language = {
    zh: zh,
    ru: ru
};

export let options = {
    language: window.localStorage.getItem('_language') || 'ru',
    url_suffix: {
        zh: '',
        ru: 'R'
    }
};

export function languageLabel(key) {
    return language[options.language][key] || "";
}

/**
 * 初始过滤器
 */
Vue.filter('label', languageLabel);
